import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { EVENT_ACTIONS } from "../../../redux/events/actions";
import {
  selectEvents,
  eventCreating,
  eventsLoaded,
  eventsMeta,
  eventsFilters
} from "../../../redux/events/selectors";
import EventForm from "../../forms/EventForm";
import { VENUES_ACTIONS } from "../../../redux/venues/actions";
import { selectVenues, venuesLoaded } from "../../../redux/venues/selectors";
import ListView from "../../../base/ListView";
import { dateRender } from "../../../libs/utils";

class _Events extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      events: this.props.events,
      eventsLoaded: this.props.eventsLoaded
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    events: PropTypes.array,
    eventsLoaded: PropTypes.bool,
    loadEvents: PropTypes.func,
    match: PropTypes.object,
    createEvent: PropTypes.func,
    updateEvent: PropTypes.func,
    deleteEvent: PropTypes.func,
    eventCreating: PropTypes.bool,
    loadVenues: PropTypes.func,
    venues: PropTypes.array,
    venuesLoaded: PropTypes.bool,
    eventsMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.loadEvents();
    this.props.loadVenues();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const id = parseInt(nextProps.match.params.id, 10);

    const newState = {
      events: nextProps.events,
      eventsLoaded: nextProps.eventsLoaded,
      activeEvent: id
        ? nextProps.events.filter(event => event.id === id)[0]
        : null
    };

    this.setState(newState);
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _mapFormToAPI(formValues) {
    const data = {
      name: formValues.name,
      dayStartTime: formValues.day_start_hour.utcOffset(0).format("hh:mm"),
      venueId: formValues.venue,
      welcomeHtml: formValues.welcomeHtml,
      registrationStartsAt: formValues.registration_start.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      registrationEndsAt: formValues.registration_end.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      registrationReminderStartsAt: formValues.reminder_start.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      registrationReminderEndsAt: formValues.reminder_end.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      bornBefore: formValues.bornBefore.format("YYYY-MM-DD")
    };

    if (formValues.previous_event && formValues.previous_event !== "") {
      data.previousEventId = formValues.previous_event;
    }

    return data;
  }

  _handleCreate(values) {
    const data = this._mapFormToAPI(values);
    this.props.createEvent(data, values.redirect);
  }

  render() {
    const { events, eventsLoaded } = this.state;
    const { eventsMeta, filters, venuesLoaded } = this.props;

    const listViewConf = {
      dataSet: events,
      dataMeta: eventsMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "updatedAt",
          value: "Updated",
          sort: "updated_at",
          render: event => dateRender(event.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        }
      ],
      actions: {
        deleteLink: false,
        detailsLink: true
      },
      url: "/admin/events"
    };

    return [
      <AdminSubHeader title="Events" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        {eventsLoaded && venuesLoaded && (
          <div className="row">
            <div className="col-xl-7">
              <ListView
                config={listViewConf}
                handleFilterUpdate={this._handleFilterUpdate}
              />
            </div>
            <div className="col-xl-5">
              <div className="m-portlet">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <span className="m-portlet__head-icon">
                        <i className="flaticon-map-location" />
                      </span>
                      <h3 className="m-portlet__head-text">Create Event</h3>
                    </div>
                  </div>
                </div>
                <EventForm
                  onSubmit={this._handleCreate}
                  isCreating={this.props.eventCreating}
                  events={this.state.events}
                  venues={this.props.venues}
                  event={this.state.activeEvent}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadEvents: params => dispatch(EVENT_ACTIONS.loadAllRequest(params)),
  loadVenues: () => dispatch(VENUES_ACTIONS.loadAllRequest()),
  createEvent: (values, redirect) =>
    dispatch(EVENT_ACTIONS.createRequest(values, redirect)),
  updateEvent: (id, values) =>
    dispatch(EVENT_ACTIONS.updateRequest(id, values)),
  deleteEvent: id => dispatch(EVENT_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(EVENT_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    events: selectEvents(state),
    eventsMeta: eventsMeta(state),
    eventsLoaded: eventsLoaded(state),
    eventCreating: eventCreating(state),
    venues: selectVenues(state),
    venuesLoaded: venuesLoaded(state),
    filters: eventsFilters(state)
  };
};

const Events = connect(mapStateToProps, mapDispatchToProps)(_Events);

export default Events;
